import { useEffect, useState } from "react";
import { AuthContext } from "./Auth/Context/AuthContext";
import Application from "./Auth/Application";
import Header from "./Components/Header";
import SideBar from "./Components/SideBar";
import Authentication from "./Auth/Authentication";
import Floor from "./Services/floorServices";
import Log from "./Services/logServices";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";
import Account from "./Services/accountServices";
import SuperUser from "./Auth/Context/SuperUser";
import { userRoles } from "./config/EnVariables";
function App() {
  const [language, setLanguage] = useState();
  const currentUser = JSON.parse(localStorage.getItem("user"));
  const [user, setUser] = useState(currentUser);
  const [shopkeepers, setShopkeepers] = useState([]);
  const [floors, setFloors] = useState([]);
  const [rents, setRents] = useState([]);
  const [logs, setLogs] = useState([]);
  const [accounts, setAccounts] = useState([]);
  const [controlSideBar, setControlSideBar] = useState(true);

  const getfloors = async () => {
    await Floor.getAllFloors().then((data) => {
      setFloors(data.data);
      console.log("Floors", data.data);
    });
  };

  const getLogs = async () => {
    await Log.getAll().then((data) => {
      setLogs(data.data);
    });
  };
  const fetchAllAccounts = () => {
    Account.getExpandingAccounts().then((acc) => {
      setAccounts(acc.data);
    });
  };
  useEffect(() => {
    if (user && user?.branchId) {
      getfloors();
      fetchAllAccounts();
      if (user.role === userRoles.admin) getLogs();
    }
  }, [user]);
  return (
    <AuthContext.Provider
      value={{
        language,
        setLanguage,
        user,
        setUser,
        shopkeepers,
        floors,
        rents,
        logs,
        controlSideBar,
        setControlSideBar,
        accounts,
      }}
    >
      {user ? (
        user.role === userRoles.superadmin ? (
          <>
            <Header />
            <SuperUser />
          </>
        ) : (
          <>
            <Header />
            <SideBar visible={controlSideBar} />
            <Application />
          </>
        )
      ) : (
        <Authentication />
      )}
    </AuthContext.Provider>
  );
}

export default App;
